import userStoreGetters from '@constans/store/user/userStoreGetters';
const getters = {
    [userStoreGetters.GET_ME]: (state) => state,
    [userStoreGetters.GET_NAME]: (state) => `${state.first_name} ${state.last_name}`,
    [userStoreGetters.GET_USER_ROLE]: state => state.user_role,
    [userStoreGetters.IS_SWEDISH_POSTAL_CODE]: (state) => state.IS_SWEDISH_POSTAL_CODE,
    [userStoreGetters.HAS_CONTACT_PERSON]: (state) => Object.values(state.contact_person).every(x => x !== ''),
    [userStoreGetters.GET_AGENT]: (state) => state.agent,
    [userStoreGetters.GET_ADDRESS_INFO]: (state) => {
        return {
            street_address: state.street_address,
            street_number: state.street_number,
            zip: state.zip,
            city: state.city,
        };
    }
};
export default getters;
